export default __webpack_public_path__ + "static/playbook-e2ecaab6c68a1dbcb0f55a601f865d7a.png";